// Single source for the strategy-call scheduling link.
// Set this to the verified dedicated Calendly event URL. While it is null, every booking surface
// shows a saved-details fallback instead of an embedded calendar; never substitute another event.
export const CALENDLY_EVENT_URL: string | null = "https://calendly.com/d/dv98-hkw-hdr/telehealthads-strategy-call";

export const CALENDLY_ORIGIN = "https://calendly.com";

export function bookingUrl(): string | null {
  if (!CALENDLY_EVENT_URL) return null;
  try {
    const u = new URL(CALENDLY_EVENT_URL);
    return u.origin === CALENDLY_ORIGIN && u.pathname.split("/").filter(Boolean).length >= 2 ? u.toString() : null;
  } catch { return null; }
}
